import { axiosApiInstancePrivate } from '../index';
import axios, { AxiosError } from 'axios';
import { QueryQuote, QuoteQueryResult } from '@tassomutuo-backoffice/types';
import configEnv from '../../../config/config';

export const getBanks = async (): Promise<string[]> => {
  try {
    const response = await axiosApiInstancePrivate.post<{
      banche: { nomebanca: string; img: string }[];
    }>(`/v1/preventivo/banche`);

    return response.data?.banche.map((b) => b.nomebanca);
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const getPurposes = async (): Promise<
  {
    label: string;
    value: string;
  }[]
> => {
  try {
    const response = await axiosApiInstancePrivate.post<{
      finalita: {
        finalita: string;
        valorebit: string;
        finalitaLabel: string;
      }[];
    }>(`/v1/preventivo/finalita`);

    return response.data?.finalita?.map((f) => ({
      label: f.finalitaLabel,
      value: f.finalita,
    }));
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

interface IQueryQuoteResponse {
  id: string;
  queryBody: {
    nomebanca: string;
    tipoTasso: string;
    durata: string;
    eta: string;
    finalita: string;
    importo: string;
    valoreImmobile: string;
    ordina: string;
  };
  queryResult: QuoteQueryResult;
}

export const getQuoteQueriesInProd = async (): Promise<QueryQuote[]> => {
  try {
    const response = await axios.get<IQueryQuoteResponse[]>(
      `${configEnv.apiUrlTassoProduction}/v1/preventivo/queries-cache/all`
    );

    return response.data.map((item) => {
      const { queryBody } = item;
      return {
        ...item,
        queryBody: {
          bank: queryBody.nomebanca,
          rateType: queryBody.tipoTasso,
          duration: queryBody.durata,
          age: queryBody.eta,
          purpose: queryBody.finalita,
          loanAmount: queryBody.importo,
          propertyValue: queryBody.valoreImmobile,
          sortBy: queryBody.ordina,
        },
      };
    });
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const getQuoteQueries = async (): Promise<QueryQuote[]> => {
  try {
    const response = await axiosApiInstancePrivate.get<IQueryQuoteResponse[]>(
      `/v1/preventivo/queries-cache/all`
    );

    return response.data.map((item) => {
      const { queryBody } = item;
      return {
        ...item,
        queryBody: {
          bank: queryBody.nomebanca,
          rateType: queryBody.tipoTasso,
          duration: queryBody.durata,
          age: queryBody.eta,
          purpose: queryBody.finalita,
          loanAmount: queryBody.importo,
          propertyValue: queryBody.valoreImmobile,
          sortBy: queryBody.ordina,
        },
      };
    });
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const createQuoteQuery = async (data: {
  bank: string;
  rateType: string;
  duration: string;
  age: string;
  purpose: string;
  loanAmount: string;
  propertyValue: string;
}): Promise<void> => {
  try {
    const response = await axiosApiInstancePrivate.post(
      `/v1/preventivo/queries-cache`,
      {
        nomebanca: data.bank,
        tipoTasso: data.rateType,
        durata: data.duration,
        eta: data.age,
        finalita: data.purpose,
        importo: data.loanAmount,
        valoreImmobile: data.propertyValue,
        ordina: 'PerRata',
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const deleteQuoteQuery = async (id: string): Promise<void> => {
  try {
    const response = await axiosApiInstancePrivate.delete(
      `/v1/preventivo/queries-cache/${id}`
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const publishQueryCacheInProd = async (
  queryCacheId: string
): Promise<void> => {
  try {
    const response = await axiosApiInstancePrivate.post<void>(
      `/v1/preventivo/queries-cache/publish-to-prod-client`,
      { queryCacheId }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};
